export const BASE_URL = 'https://backbonedev.scanandorder.eu/api';

export const CLOUDINARY_BASE_URL =
    'https://res.cloudinary.com/scanandorder/image/upload';

export const PRODUCT_CATEGORIES = '/product-categories';
export const PRODUCTS = '/products';
export const EMPLOYEES = '/employees';
export const TABLES = '/tables';
export const CONFIGURATION = '/configuration';
export const ACCOUNT = '/account';
export const STORE_CLOSING = '/store-closing';

export const COOKIE_TOKEN_KEY = 'api_token';

export const required =
    (error: string = 'Required field') =>
    (value: string) =>
        value ? undefined : error;

export const ACCOUNT_NS = 'account';
export const CATEGORIES_NS = 'categories';
export const EMPLOYEES_NS = 'employees';
export const USER_NS = 'user';
export const MENU_NS = 'menu';
export const PRODUCTS_NS = 'products';
export const STORE_CONFIG_NS = 'storeConfiguration';
export const TABLES_NS = 'tables';
export const STORE_CLOSING_NS = 'storeClosing';
